import { loadStripe, Stripe } from '@stripe/stripe-js';

/*
 * Which Stripe account the browser talks to — mirrors the server's STRIPE_TOGGLE.
 * Set REACT_APP_STRIPE_TOGGLE to 'legacy' (and rebuild the client) together with the
 * server to route Stripe.js at the OLD account's publishable key. The key MUST match
 * the account the server put the PaymentIntent / subscription on, or Stripe.js rejects
 * the client secret.
 *
 *   REACT_APP_STRIPE_TOGGLE                  = new | legacy   (default new)
 *   REACT_APP_STRIPE_PUBLISHABLE_KEY         -> NEW account
 *   REACT_APP_STRIPE_LEGACY_PUBLISHABLE_KEY  -> OLD account
 */
const TOGGLE = (process.env.REACT_APP_STRIPE_TOGGLE || 'new').trim().toLowerCase();

export const activeStripePublishableKey =
  TOGGLE === 'legacy'
    ? process.env.REACT_APP_STRIPE_LEGACY_PUBLISHABLE_KEY ||
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Single shared Stripe.js instance (loadStripe is meant to be called once per key).
export const stripePromise: Promise<Stripe | null> = loadStripe(
  activeStripePublishableKey!
);
